// $(document).on("click", ".link_to_page", (e) => {
// 	let el = e.currentTarget;
	
// 	let title = $(el).data("title")
// 	let is_public = $(el).data("is_public")
// 	let is_link = $(el).data("is_link")

// 	if(is_link) {
// 		frappe.set_route("List", title)
// 		return;
// 	}

// 	let url = "/app/" 
// 	url += is_public ? frappe.router.slug(title): "private/" + frappe.router.slug(title)

// 	frappe.set_route(url)
// })
$(document).on("click", ".link_to_page", (e) => {
    if (e.ctrlKey || e.metaKey || e.which === 2) {
        return;
    }

    e.preventDefault();

    $(".link_to_page.active").removeClass("active")

    let el = e.currentTarget;
    $(el).addClass("active")
    
    let title = $(el).data("title");

    let is_public = String($(el).data("is_public")) === "1";
    let is_link   = String($(el).data("is_link")) === "1";

    let url = "/app/" + frappe.router.slug(title);
    if (!is_public) {
        url = "/app/private/" + frappe.router.slug(title);
    }

    $(el).attr("href", url);

    if (is_link) {
        frappe.set_route("List", title);
    } else {
        frappe.set_route(url);
    }
});


